import { compensationApiBaseUrl } from '../../shared/env';
import { createJsonClient } from '../../shared/httpClient';
import type { EmployeeReadinessGateway } from './EmployeeReadinessGateway';
import type { EmployeeSetupReadiness, EmployeeSetupReadinessBatch } from './types';

export class HttpEmployeeReadinessGateway implements EmployeeReadinessGateway {
  private readonly request = createJsonClient(compensationApiBaseUrl);

  getReadiness(employeeId: string, asOf?: string, signal?: AbortSignal): Promise<EmployeeSetupReadiness> {
    const query = asOf ? `?asOf=${encodeURIComponent(asOf)}` : '';
    return this.request(`/api/employee-setup-readiness/${encodeURIComponent(employeeId)}${query}`, undefined, signal);
  }

  queryReadiness(employeeIds: string[], asOf?: string, signal?: AbortSignal): Promise<EmployeeSetupReadinessBatch> {
    return this.request(
      '/api/employee-setup-readiness/query',
      { method: 'POST', body: JSON.stringify({ employeeIds, ...(asOf ? { asOf } : {}) }) },
      signal,
    );
  }
}
